import { render, staticRenderFns } from "./SelectReserveTypeInfo.vue?vue&type=template&id=7420d348&"
import script from "./SelectReserveTypeInfo.vue?vue&type=script&lang=ts&"
export * from "./SelectReserveTypeInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SelectReserveTypeInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports